import React from 'react';
import './PcaHero.css';

function PcaHero() {
  return (
    <section className="hero">
      <div className="hero__pill">
        <span className="hero__pill-dot"></span>
        Exclusive offer for <em className="hero__highlight hero__italic">Porsche Club of America</em> members
      </div>
      {/* 
      <h1 className="hero__title">
        <span className="hero__title-line">Your Online Auction Companion</span>
        <span className="hero__title-line">That Gives You <span className="hero__highlight">Auction Data</span></span>
        <span className="hero__title-line">While You Browse Listings</span>
      </h1>
      */}
      <h1 className="hero__title">
        <span className="hero__title-line">Lifetime Porsche Access.</span>
        <span className="hero__title-line"><em className="hero__highlight hero__italic">Pay once. </em>Never renew.</span>
      </h1>
      <p className="hero__subtitle">
        PCA members get Bidder iQ for life for $396, the price everyone else<br />
        pays annually. Real data from 15,000+ Porsche auction results, so you<br />
        never overpay or undersell again.
      </p>
      <div className="hero__cta-row">
        <a href="/pca#pricing" className="hero__cta">Claim Lifetime Porsche Access</a>
        <a href="https://www.loom.com/share/65f2f6070c384921b5eef534644acd41" target="_blank" rel="noopener noreferrer" className="hero__cta hero__cta--secondary">See How It Works</a>
      </div>
      <p className="hero__trust">
        Limited to <strong>250 PCA members</strong> or until <strong>December 31, 2026</strong>, whichever comes first.
      </p>
      <ul className="hero__benefits">
        <li><span className="hero__benefit-check">✓</span> Pay once, keep it forever</li>
        <li><span className="hero__benefit-check">✓</span> Real sold &amp; unsold data</li>
        <li><span className="hero__benefit-check">✓</span> Chrome Extension included</li>
        <li><span className="hero__benefit-check">✓</span> Every future Porsche feature</li>
      </ul>
    </section>
  );
}

export default PcaHero;
